import { gql } from "@apollo/client"

const filterRapidTestsForHCPAdmin = ({ isHCPAdmin }) => {
  if (!isHCPAdmin) {
    return ``
  }

  return `
    test_id: { _eq: $rapidTestId }
  `
}

const GET_COUNT_BY_STATUS = ({ isHCPAdmin }) => gql`
  query CountByStatus(
    $partner_id: Int
    $client_ids: [Int!]
    $isHCPAdmin: Boolean!
    $isHCPOrCanViewRapidTests: Boolean!
    $rapidTestId: Int
    $excludeRegisteredKitsWithIds: [Int!]
    $includeResultsEnteredKitsWithIds: [Int!]
  ) {
    registered: lens_kit_results_view_aggregate(
      where: {
        ${filterRapidTestsForHCPAdmin({ isHCPAdmin })}

        id: { _nin: $excludeRegisteredKitsWithIds }
        status: { _neq: "results_approved" }
        barcode_state: { _eq: "registered" }
        barcode_in_transit_at: { _is_null: true }
        _or: {
          enterprise_partner_id: { _eq: $partner_id }
          enterprise_client_id: { _in: $client_ids }
        }
      }
    ) {
      aggregate {
        count
      }
    }

    in_transit: lens_kit_results_view_aggregate(
      where: {
        ${filterRapidTestsForHCPAdmin({ isHCPAdmin })}

        id: { _nin: $excludeRegisteredKitsWithIds }
        status: { _neq: "results_approved" }
        barcode_state: { _eq: "registered" }
        barcode_in_transit_at: { _is_null: false }
        _or: {
          enterprise_partner_id: { _eq: $partner_id }
          enterprise_client_id: { _in: $client_ids }
        }
      }
    ) {
      aggregate {
        count
      }
    }

    retrievable_results: lens_kit_results_view_aggregate(
      where: {
        ${filterRapidTestsForHCPAdmin({ isHCPAdmin })}

        id: { _nin: $excludeRegisteredKitsWithIds }
        status: { _neq: "results_approved" }
        barcode_state: { _eq: "processed" }
        _or: {
          enterprise_partner_id: { _eq: $partner_id }
          enterprise_client_id: { _in: $client_ids }
        }
      }
    ) @skip(if: $isHCPAdmin) {
      aggregate {
        count
      }
    }

    approved_results_entered: lens_kit_results_view_aggregate(
      where: {
        ${filterRapidTestsForHCPAdmin({ isHCPAdmin })}

        id: { _in: $includeResultsEnteredKitsWithIds }
        status: { _eq: "results_approved" }
        _or: {
          enterprise_partner_id: { _eq: $partner_id }
          enterprise_client_id: { _in: $client_ids }
        }
      }
    ) @include(if: $isHCPOrCanViewRapidTests) {
      aggregate {
        count
      }
    }

    approved: lens_kit_results_view_aggregate(
      where: {
        ${filterRapidTestsForHCPAdmin({ isHCPAdmin })}

        status: { _eq: "results_approved" }
        _or: {
          enterprise_partner_id: { _eq: $partner_id }
          enterprise_client_id: { _in: $client_ids }
        }
      }
    ) {
      aggregate {
        count
      }
    }

    canceled: lens_kit_results_view_aggregate(
      where: {
        ${filterRapidTestsForHCPAdmin({ isHCPAdmin })}

        status: { _eq: "archived" }
        _or: {
          enterprise_partner_id: { _eq: $partner_id }
          enterprise_client_id: { _in: $client_ids }
        }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`

export default GET_COUNT_BY_STATUS
